import styled, { css } from "styled-components";
/**
 * Component's wrapper component
 */

export var Section = /*#__PURE__*/ styled.section.withConfig({
  displayName: "Cardstyle__Section"
})(_ref => {
  var { theme } = _ref;
  return css(
    [
      "background-color:",
      ";border:1px solid ",
      ";border-radius:10px;display:flex;flex-direction:column;overflow:auto;"
    ],
    theme.colors.white,
    theme.colors.grey.grey25
  );
});
